export enum ErrorMessageEnum {
	REQUIRED = "Toto pole je povinné",
	EMAIL = "Špatný formát e-mailové adresy",
	PASSWORD_MATCH = "Hesla nejsou shodná",
	PASSWORD_STRENGTH = "Síla hesla není dostačující",
	PHONE = "Špatný formát čísla. Vložte v formátu +420 123 456 789",
	DATE = "Datum neni ve správném formátu",
}

export enum ErrorMessageEnumApi {
	RESET_PWD_000 = "Operace dopadla úspěšně.",
	RESET_PWD_001 = "Nepodařilo se odeslat sms či e-mail.",
	RESET_PWD_002 = "Neplatný typ tokenu.",
	RESET_PWD_003 = "Odkaz pro nastavení hesla je expirovaný nebo neplatný.",
	RESET_PWD_004 = "Špatný nebo expirovaný kód. Zkontrolujte prosím, zda je přepsán správně.",
	RESET_PWD_005 = "Telefon není napárovaný k uvedenému e-mailu. ",
	RESET_PWD_006 = "Je nám líto, pro tento účet se nepodařilo odeslat e-mail k nastavení nového hesla.",
	RESET_PWD_999 = "Vyskytla se chyba.",
	SERVER_ERROR = "Vyskytla se neočekávaná chyba.",
	RATELIMIT_001 = "RATELIMIT_001",
}
